"use strict";

var _Column, _Column2, _Text, _Column3;
import { UserMenuHolder } from '@autoguru/components';
import { CDN, RETAIL_URL } from '@autoguru/global-configs';
import { HeaderLayout } from '@autoguru/header-layout';
import { Box, Column, Columns, Text } from '@autoguru/overdrive';
import { Picture } from '@autoguru/picture';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const pageHeaderPortalId = '__ag-header__';
const LogoImage = /*#__PURE__*/_jsx(Picture, {
  aspectRatio: 5.1,
  height: 24,
  backgroundColor: "transparent",
  src: `${CDN}/images/logos/autoguru.svg`,
  altText: "AutoGuru logo"
});
export const AppHeader = () => {
  return /*#__PURE__*/_jsx(HeaderLayout, {
    safePaddings: true,
    children: /*#__PURE__*/_jsxs(Columns, {
      space: "5",
      children: [_Column || (_Column = /*#__PURE__*/_jsx(Column, {
        noShrink: true,
        alignSelf: "centre",
        children: /*#__PURE__*/_jsx(Box, {
          as: "a",
          href: RETAIL_URL,
          children: LogoImage
        })
      })), /*#__PURE__*/_jsx(Column, {
        grow: true,
        alignSelf: "centre",
        children: /*#__PURE__*/_jsxs(Columns, {
          width: "full",
          space: "3",
          children: [_Column2 || (_Column2 = /*#__PURE__*/_jsx(Column, {
            grow: true,
            alignSelf: "centre",
            children: /*#__PURE__*/_jsx("span", {})
          })), /*#__PURE__*/_jsx(Column, {
            noShrink: true,
            alignSelf: "centre",
            children: /*#__PURE__*/_jsx(Box, {
              as: "a",
              href: `${RETAIL_URL}/contact-us`,
              target: "_blank",
              rel: "noopener noreferrer"
              // biome-ignore lint/a11y/useSemanticElements: migration quick fix. To be fixed when code is touched
              ,
              role: "link",
              "aria-label": "Contact AutoGuru",
              children: _Text || (_Text = /*#__PURE__*/_jsx(Text, {
                size: "3",
                children: "Contact us"
              }))
            })
          })]
        })
      }), _Column3 || (_Column3 = /*#__PURE__*/_jsx(Column, {
        noShrink: true,
        alignSelf: "centre",
        children: /*#__PURE__*/_jsx(UserMenuHolder, {})
      }))]
    })
  });
};